import React from 'react'
import { Skeleton, SkeletonCircle, SkeletonText,Box } from "@chakra-ui/react";
const Skeletonloading = () => {
  return (
    <>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
      <Box padding="6" boxShadow="lg" bg="white">
        <Box display="flex" justifyContent={"space-between"}>
          <SkeletonCircle size="12" />
          <SkeletonCircle size="12" />
        </Box>
        <SkeletonText mt="5" noOfLines={3} spacing="2" />
      </Box>
    </>
  );
}

export default Skeletonloading